export const SIZES = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
} as const;

export const SKINS = {
  DARK: 'dark',
  STANDARD: 'standard',
} as const;
